<glxy-chat-container #chatContainer [animationDuration]="200">
  <!-- show typing indicator first, so it always appears at the bottom of the chat -->
  <glxy-chat-message-group
    *ngIf="isAIBotLoading"
    [type]="RECEIVED"
    [messageFrom]="VENDASTA_SSO_AI"
    [showProfilePic]="true"
    [profileSVGIcon]="BOT_SVG_ICON"
    [profileBackgroundColor]="BOT_BACKGROUND_COLOR"
  >
    <glxy-chat-message [isTyping]="true"></glxy-chat-message>
  </glxy-chat-message-group>

  <ng-container *ngFor="let message of messages; let i = index">
    <ng-container *ngIf="message.type === SENT">
      <glxy-chat-message-group [type]="message.type" [messageFrom]="message.messageFrom">
        <ng-container>
          <glxy-chat-message [messageText]="message.messageText"></glxy-chat-message>
        </ng-container>
      </glxy-chat-message-group>
    </ng-container>

    <ng-container *ngIf="message.type === RECEIVED">
      <glxy-chat-message-group
        [type]="message.type"
        [messageFrom]="message.messageFrom"
        [showProfilePic]="message.showProfilePic"
        [profileSVGIcon]="message.profileSVGIcon"
        [profileBackgroundColor]="message.profileBackgroundColor"
      >
        <ng-container>
          <glxy-chat-message [messageText]="message.messageText"></glxy-chat-message>
        </ng-container>
      </glxy-chat-message-group>
    </ng-container>
  </ng-container>
</glxy-chat-container>

<glxy-form-field [showLabel]="false" [bottomSpacing]="false">
  <glxy-label>Message Input</glxy-label>
  <textarea
    #textArea
    matInput
    placeholder="Type a message..."
    cdkTextareaAutosize
    cdkAutosizeMinRows="3"
    cdkAutosizeMaxRows="10"
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="sendMessage()"
    [disabled]="isAIBotLoading"
  ></textarea>
  <glxy-hint>
    Press
    <code>Enter</code>
    to send
  </glxy-hint>
</glxy-form-field>
